import { $ } from '../util/view';
import { cast as castArray } from '../util/array';
import { getCurrentPageChannel } from '../util/channel';
const createFormValue = (name, value) => $('input', {
    name,
    type: 'hidden',
    value,
});
export default function ({ attributes = {}, children, consent, }) {
    const builtInInputs = [
        createFormValue('consent', consent ? 'yes' : 'no'),
        createFormValue('domain', location.origin),
    ];
    const channel = getCurrentPageChannel();
    if (channel) {
        builtInInputs.push(createFormValue('channel', channel));
    }
    return $('form', {
        action: 'javascript:void(0);',
        ...attributes,
    }, [...builtInInputs, ...castArray(children)]).submit(() => localStorage.setItem('mol.ads.cmp.alert', 'true'));
}
